import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {RequestMethod, Response} from "@angular/http";
import {RequestConfig, RestResponse} from "../../../../shared/rest/rest.request";
import {CustomHttp} from "../../../../common/http/custom.http";
import {PageImpl} from "../../../../common/http/PageImpl";
import { NzI18nService ,es_ES} from "ng-zorro-antd";

@Injectable()
export class TipoTicketService {
    private CREATE_CODE = new RequestConfig("TPT", "application/json", true, RequestMethod.Post, "/types/tickets");
    private EDIT_CODE = new RequestConfig("TPT", "application/json", true, RequestMethod.Put, "/types/tickets/{typeId}");
    private DELETE_CODE = new RequestConfig("TPT", "application/json", true, RequestMethod.Delete, "/types/tickets/{typeId}");
    private GET_CODE = new RequestConfig("TPT", "application/json", true, RequestMethod.Get, "/types/tickets/{typeId}");
    private GET_PAGE = new RequestConfig("TPT", "application/json", true, RequestMethod.Get, "/types/tickets");
    private GET_ALL = new RequestConfig("TPT", "application/json", true, RequestMethod.Get, "/types/tickets/allTypesTicket");
    private GET_INFO_TYPES_TICKET = new RequestConfig("TPT", "application/json", true, RequestMethod.Post, "/types/tickets/find");

    constructor(private http: CustomHttp,
        private i18n: NzI18nService) {
            this.i18n.setLocale(es_ES);
    }

    /**
     * Envia una petición a WS para guardar tipos de ticket
     */
    saveTiposTicket(tipoTicket: TipoTicket): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, tipoTicket)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de tipo de ticket
     */
    getTipoTicket(idTicketType: number): Observable<TipoTicket> {
        return this.http.sendRequest(this.GET_CODE, {}, idTicketType)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar datos de tipo de ticket
     */
    updateTipoTicket(tipoTicket: TipoTicket): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, tipoTicket, tipoTicket.idTicketType)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de tipo de ticket
     */
    deleteTipoTicket(idTicketType: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idTicketType)
            .catch(error => this.http.handleError(error));
    }

    /**
     * Obtener todos los tipos de Ticket
     */
    findAll(): Observable<Array<TipoTicket>> {
        let allTypesTicket: any = localStorage.getItem('allTypesTicket');
        if (allTypesTicket != undefined || allTypesTicket != null) {
            let allTypesTicketParse = JSON.parse(allTypesTicket)
            if (allTypesTicketParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(allTypesTicketParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_ALL)
                .map((res: any) => {
                    try {
                        localStorage.setItem('allTypesTicket', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };

        // return this.http.sendRequest(this.GET_ALL)
        //     .map(res => res.json())
        //     .catch(error => this.http.handleError(error));
    }
    findAllTypeTicket(): Observable<Array<TicketTypeView>> {
        let allTypesTicket: any = localStorage.getItem('allTypesTicket');
        if (allTypesTicket != undefined || allTypesTicket != null) {
            let allTypesTicketParse = JSON.parse(allTypesTicket)
            if (allTypesTicketParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(allTypesTicketParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_ALL)
                .map((res: any) => {
                    try {
                        localStorage.setItem('allTypesTicket', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };
        // return this.http.sendRequest(this.GET_ALL)
        //     .map(res => res.json())
        //     .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<TipoTicket>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia una petición a WS para obtener informacion completa de x tipos de tickets
     */
    getInfoTiposTicket(tipoTicketView?: TicketTypeRequestView): Observable<Array<TipoTicket>> {
        tipoTicketView = tipoTicketView || new TicketTypeRequestView();
        let infoTiposTicket: any = localStorage.getItem('infoTiposTicket');
        if (infoTiposTicket != undefined || infoTiposTicket != null) {
            let infoTiposTicketParse = JSON.parse(infoTiposTicket)
            if (infoTiposTicketParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(infoTiposTicketParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_INFO_TYPES_TICKET, tipoTicketView)
                .map((res: any) => {
                    try {
                        localStorage.setItem('infoTiposTicket', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };
    }

    findInfoTicketTypes(tipoTicketView: TicketTypeRequestView): Observable<Array<TipoTicket>> {
        let findInfoTicketTypes: any = localStorage.getItem('findInfoTicketTypes');
        if (findInfoTicketTypes != undefined || findInfoTicketTypes != null) {
            let findInfoTicketTypesParse = JSON.parse(findInfoTicketTypes)
            if (findInfoTicketTypesParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(findInfoTicketTypesParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_INFO_TYPES_TICKET, tipoTicketView)
            .map((res: any) => {
                    try {
                        localStorage.setItem('findInfoTicketTypes', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };
    }
}

@Injectable()
export class TipoTicket {
    public idTicketType: number;
    public ticketType: string;
    public typeTicket: string;
    public proccesInstanceName: string;
    public taskInstanceName: string;
    public prefix: string;
}

@Injectable()
export class TicketTypeRequestView {
    public idTicketTypes: Array<number>;
    public idTicketCategories: Array<number>;
    public idTypeTicket: number;
    public active?:boolean;
}

@Injectable()
export class TipoTicketEdit {
    public idTicketType: number;
    public ticketType: string;
    public checked: boolean;
}

@Injectable()
export class TaskTypeRequestView {
    public idTaskTypes: Array<number>;
    public idTaskCategories: Array<number>;
    public idTypeTask: number;
}

@Injectable()
export class TicketTypeView {
    private idTicketType:	number;
    private typeTicket:	string;

} {

}

export class TypeTicketAdvanceSearch {
    active: boolean;
    ticketType: string;
    page: number;
    size: number;
    columnOrder: string;
    //orderType: string;
    order:string;

  //  content: TypeContentTicketAdvanceSearch = new TypeContentTicketAdvanceSearch;
}

export class TypeContentTicketAdvanceSearch {
    proccesInstanceName: string;
    taskInstanceName: string;
    ticketType: string;
}


